module.exports = __webpack_public_path__ + "static/media/Coupons_Redeemed_Icon.01afb84f.png";